export const handleSinglePlural = (count: number, text: string) => {
  return count === 0
    ? `Not ${text.toLowerCase()} yet`
    : count === 1
      ? `${text} ${count} time`
      : `${text}  ${count} times`;
};
